const renderFormPartASummary = partAForm => {
    const activityList = Array.isArray(partAForm?.all_activities_list)
      ? partAForm.all_activities_list.filter(Boolean)
      : []
    const purposeList = Array.isArray(partAForm?.purpose_list)
      ? partAForm.purpose_list.filter(Boolean)
      : []

    const renderChipList = (list, chipClass) => {
      if (!list.length) {
        return (
          <div className='border rounded p-3 bg-white text-muted'>
            No records provided
          </div>
        )
      }

      return (
        <div className='d-flex flex-wrap'>
          {list.map(item => (
            <span 
                key={item} className={`badge badge-pill px-3 py-2 mr-2 mb-2 ${chipClass}`} 
                style={{backgroundColor: '#3673ac', color: '#ffffff', borderRadius: '8px', fontSize: '14px'}}
            >
              {item}
            </span>
          ))}
        </div>
      )
    }

    return (
      <div className='card border-0 shadow-sm mb-3'>
        <div className='card-header bg-light py-3'>
          <div className='d-flex align-items-center justify-content-between flex-wrap'>
            <h4 className='sub mb-0' style={{fontWeight: 'bold'}}>Form Part A - Summary</h4>
            <span className='badge badge-light border text-muted px-3 py-2 mt-2 mt-md-0'>
              Linked Application Snapshot
            </span>
          </div>
        </div>

        <div className='card-body bg-white border'>
          <div className='row mb-2'>
            <div className='col-md-6 mb-3 mb-md-0'>
              <div className='text-muted text-uppercase'>Form Number</div>
              <div className='font-weight-bold text-dark'>{partAForm?.form_num || 'N/A'}</div>
            </div>
            <div className='col-md-6'>
              <div className='text-muted text-uppercase'>Project Island</div>
              <div className='font-weight-bold text-dark'>{partAForm?.project_island || 'N/A'}</div>
            </div>
            <div className='col-md-6'>
              <div className='text-muted text-uppercase'>Postal Address</div>
              <div className='font-weight-bold text-dark'>{partAForm?.postal_address || 'N/A'}</div>
            </div>
            <div className='col-md-6'>
              <div className='text-muted text-uppercase'>Project Category</div>
              <div className='font-weight-bold text-dark'>{partAForm?.project_category || 'N/A'}</div>
            </div>
          </div>

          <hr className='my-3' />

          <div className='mb-3'>
            <div className='d-flex justify-content-between align-items-center mb-2'>
              <div className='text-muted text-uppercase mb-0'>Activity List</div>
              <span className='badge badge-light border text-muted px-3 py-2'>{activityList.length}</span>
            </div>
            {renderChipList(activityList, 'badge-lightx border')}
          </div>

          <div>
            <div className='d-flex justify-content-between align-items-center mb-2'>
              <div className='text-muted text-uppercase mb-0'>Purpose List</div>
              <span className='badge badge-light border text-muted px-3 py-2'>{purposeList.length}</span>
            </div>
            {renderChipList(purposeList, 'badge-lightx border')}
          </div>
        </div>
      </div>
    )
  }

  const renderFormPartAFullDetails = partAForm => {
    const apiHost = `${process.env.REACT_APP_API_HOST || ''}`.trim()

    const formatLabel = key =>
      key
        .replace(/_/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/\b\w/g, c => c.toUpperCase())

    const normalizeLineBreaks = value => {
      if (typeof value !== 'string') return value

      return value
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/\\n/g, '\n')
    }

    const formatNestedObject = obj => {
      if (!obj || typeof obj !== 'object') return 'N/A'

      return Object.entries(obj)
        .map(([k, v]) => {
          const formattedValue =
            v === null || v === undefined || v === ''
              ? 'N/A'
              : typeof v === 'boolean'
                ? v ? 'Yes' : 'No'
                : normalizeLineBreaks(`${v}`)

          return `${formatLabel(k)}: ${formattedValue}`
        })
        .join(' | ')
    }

    const formatValue = value => {
      if (value === null || value === undefined || value === '') return 'N/A'
      if (typeof value === 'boolean') return value ? 'Yes' : 'No'

      if (Array.isArray(value)) {
        if (!value.length) return 'N/A'

        const formatted = value
          .map(item => {
            if (item === null || item === undefined || item === '') return null
            if (typeof item === 'boolean') return item ? 'Yes' : 'No'
            if (typeof item === 'object') return formatNestedObject(item)
            return normalizeLineBreaks(`${item}`)
          })
          .filter(Boolean)

        return formatted.length ? formatted.join(' | ') : 'N/A'
      }

      if (typeof value === 'object') return formatNestedObject(value)

      return normalizeLineBreaks(`${value}`)
    }

    const applyFieldFormat = (field, value) => {
      if (!field || typeof field.format !== 'function') return value

      try {
        return field.format(value)
      } catch (error) {
        return value
      }
    }

    const getImageUrl = imageItem => {
      if (!imageItem) return null

      const withApiHost = rawUrl => {
        if (!rawUrl) return null

        const normalizedUrl = `${rawUrl}`.trim()
        if (!normalizedUrl) return null

        if (/^(https?:)?\/\//i.test(normalizedUrl) || normalizedUrl.startsWith('data:') || normalizedUrl.startsWith('blob:')) {
          return normalizedUrl
        }

        if (!apiHost) return normalizedUrl

        const base = apiHost.endsWith('/') ? apiHost.slice(0, -1) : apiHost
        const path = normalizedUrl.startsWith('/') ? normalizedUrl : `/${normalizedUrl}`
        return `${base}${path}`
      }

      if (typeof imageItem === 'string') return withApiHost(imageItem)

      if (typeof imageItem === 'object') {
        return withApiHost(imageItem.url || imageItem.src || imageItem.path || imageItem.location || null)
      }

      return null
    }

    const getImageForField = field => {
      if (!field?.key || typeof field.key !== 'string') return null

      const [group, indexLabel] = field.key.split('.')
      if (group !== 'image') return null

      const fromFieldValue = getImageUrl(partAForm?.[field.name])
      if (fromFieldValue) return fromFieldValue

      const imageStore = partAForm?.image
      const parsedIndex = Number(indexLabel)

      if (!Number.isInteger(parsedIndex)) return null

      let imageItem = null

      if (Array.isArray(imageStore)) {
        imageItem = imageStore[parsedIndex] || imageStore[parsedIndex - 1]
      } else if (imageStore && typeof imageStore === 'object') {
        imageItem =
          imageStore[parsedIndex]
          || imageStore[String(parsedIndex)]
          || imageStore[parsedIndex - 1]
          || imageStore[String(parsedIndex - 1)]
      }

      return getImageUrl(imageItem)
    }

    const renderTextItem = (text, index) => {
      if (text === '::SPACER') {
        return <div key={`spacer-${index}`} className='col-12 mb-2' />
      }

      const content = text.startsWith('::') ? text.slice(2).trim() : text
      if (!content) return null

      return (
        <div key={`text-${index}`} className='col-12 info-invoice'>
          <p className='sub mb-2' style={{ wordBreak: 'break-word' }}>
            {content}
          </p>
        </div>
      )
    }

    const renderHeadingItem = (heading, index) => {
      if (!heading) return null

      return (
        <div
          key={`heading-${index}`}
          className='col-12 info-invoice'
          dangerouslySetInnerHTML={{ __html: heading }}
        />
      )
    }

    const renderFieldItem = (field, index) => {
      const imageUrl = getImageForField(field)
      const isUploadField = typeof field?.key === 'string' && field.key.startsWith('image.')
      if (!partAForm) return null

      if (!isUploadField && (!field?.name || !(field.name in partAForm))) return null

      if (isUploadField) {
        return (
          <div key={`${field.name}-${index}`} className='col-md-6 col-lg-4 info-invoice'>
            <h5 className='sub'>{field.label || formatLabel(field.name)}</h5>
            {imageUrl ? (
              <>
                <a href={imageUrl} target='_blank' rel='noopener noreferrer'>
                  <div>
                    <div>(Click to view)</div>
                    <img
                      src={imageUrl}
                      alt={field.label || formatLabel(field.name)}
                      style={{
                        width: '60px',
                        height: '60px',
                        objectFit: 'cover',
                        borderRadius: '6px',
                        border: '1px solid #d7d7d7'
                      }}
                      onError={event => {
                        const link = event.currentTarget.closest('a')
                        if (link) link.style.display = 'none'

                        const fallback = event.currentTarget.closest('.info-invoice')?.querySelector('[data-image-na]')
                        if (fallback) fallback.style.display = 'block'
                      }}
                    />
                  </div>
                </a>
                <p data-image-na style={{ display: 'none' }}>N/A</p>
              </>
            ) : (
              <p>N/A</p>
            )}
          </div>
        )
      }

      const rawValue = applyFieldFormat(field, partAForm[field.name])
      const formattedValue = formatValue(rawValue)
      const isLong = formattedValue.length > 120 || formattedValue.includes('|') || formattedValue.includes('\n')
      const classes = isLong
        ? 'col-md-12 info-invoice'
        : 'col-md-6 col-lg-4 info-invoice'

      const latitude = Number(partAForm.latitude)
      const longitude = Number(partAForm.longitude)
      const hasValidCoordinates = Number.isFinite(latitude) && Number.isFinite(longitude)
      const openStreetMapsUrl = hasValidCoordinates
        ? `https://www.openstreetmap.org/?mlat=${latitude}&mlon=${longitude}#map=17/${latitude}/${longitude}`
        : null
      const googleMapsUrl = hasValidCoordinates
        ? `https://www.google.com/maps?q=${encodeURIComponent(`${latitude},${longitude}`)}`
        : null
      const showMapsLink = field.name === 'latitude' && !!googleMapsUrl

      return (
        <div key={`${field.name}-${index}`} className={classes}>
          <h5 className='sub'>{field.label || formatLabel(field.name)}</h5>
          <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{formattedValue}</p>
          {showMapsLink ? (
            <p className='mb-0 d-flex flex-wrap align-items-center'>
              <a href={googleMapsUrl} target='_blank' rel='noopener noreferrer'>
                (View on Google Maps)
              </a>
              <a href={openStreetMapsUrl} target='_blank' rel='noopener noreferrer' className=''>
                (View on OpenStreetMap)
              </a>
            </p>
          ) : null}
        </div>
      )
    }

    const renderedItems = formPartAFields
      .map((field, index) => {
        if (typeof field === 'string') return renderTextItem(field, index)
        if (field?.heading) return renderHeadingItem(field.heading, index)
        if (field?.name) return renderFieldItem(field, index)
        return null
      })
      .filter(Boolean)

    return (
      <div className='mb-3'>
        <div className='bg-white'>
          <div className='row'>
            {renderedItems}
          </div>
        </div>
      </div>
    )
  }

  const formPartAFields = [
    {
        heading: '<h2>PART A</h2>'
    },
    {
      name: 'form_num',
      label: 'Application ID',
    },
    {
      name: 'created_at',
      label: 'Date Submitted',
      type: 'date',
      format: v => new Date(v).toLocaleDateString(),
    },
    {
      name: 'application_decision',
      label: 'Application Status',
      format: v => v.toUpperCase(),
    },

    "::Applicant Information",
    {
        name: 'postal_address'
    },
    {
        name: 'phone_number',
        label: 'Phone #',
        type: 'phone',
        required: false,
    },
    {
        name: 'phone_number_alt',
        label: 'Alternate Phone #',
        type: 'phone',
        required: false,
    },
    {
        heading: '<h4 style="font-weight:bold;">Project Classification</h4>'
    },
    {
        heading: `<p>1. Please state the Activity as well as the purpose of the project for which the Certificate of Environmental Clearance application is being submitted.</p>`,
    },
    {
        name: 'all_activities_list',
        label: 'List all the activities that apply:',
        columns: ['activity'],
        format: v => v.join('\n '),
    },
    {
        name: 'purpose_list',
        label: '2. Purpose',
        hint: 'Select all that apply',
        columns: ['purpose'],
        format: v => v.join('\n '),
    },
    {
        name: 'purpose_ghost',
        label: '2. Purpose',
        hint: 'Select all that apply',
        type: 'checklist',
        multi: true,
        options: [],
        view: false,
    },
    {
        name: 'purpose_other',
        label: 'Other Purpose',
        columns: ['purpose'],
        view: false
    },

    `::3. Is the project located in an environmentally sensitive area as defined by Environmental Planning and Protection 
    (Amendment) Act, 2024, i.e. “environmentally sensitive area means an area (a) in which plant or animal life or 
    their habitats are either rare or especially valuable because of their special nature or role in any ecosystem and 
    which may be easily disturbed or degraded by human activities and developments; and (b) designed under section 
    23;`,
    {
        name: 'environmentally_sensitive_area',
        label: `Is the project located in an environmentally sensitive area as defined by Environmental Planning and Protection 
            (Amendment) Act, 2024`,
        type: 'select:bool',
    },
    {
        name: 'project_category',
        label: 'Select a category that Certificate of Environmental Clearance (CEC) applies to',
        options: ['New', 'Modification', 'Abandonment', 'Decommissioning']
    },


    "::SPACER",
    {
        heading: '<h4 style="font-weight:bold;">A. General Information</h4>'
    },

    "::4. Location of proposed activity",
    {
      name: 'latitude',
      label: 'Latitude',
      type: 'number',
    },
    {
      name: 'longitude',
      label: 'Longitude',
      type: 'number',
    },
    {
        name: 'project_island',
        label: 'Island/Constituency',
    },
    {
        name: 'project_street_address',
        label: 'Street Address',
    },
    {
        name: 'project_lot_no',
        label: 'Lot No.',
    },

    "::5. Please complete the following:",
    {
        name: 'own_property',
        label: 'Do you own the property on which the activity is intended to be carried out?',
        type: 'select:bool',
    },
    {
        name: 'adjourning_owners_list',
        label: '6. Names and addresses of adjourning property owners',
        fields: ['first_name', 'last_name', 'address'],
        format: v => JSON.parse(v),
    },

    "::SPACER",
    "::7. Site description (physical setting of the proposal, both developed and undeveloped area)",
    {
        name: 'total_area',
        label: `Total area intended for the activity`,
        type: 'number',
    },
    {
        name: 'coast_distance',
        label: `How far is the projected lot from the coast`,
        type: 'number',
    },
    {
        name: 'previous_site_use',
        label: 'Previous site land use',
        options: [
            'Residential',
            'Agricultural',
            'Commercial',
            'Industrial',
            'Forestry',
        ],
    },
    {
        name: 'present_site_use',
        label: 'Present site land use',
        options: [
            'Residential',
            'Agricultural',
            'Commercial',
            'Industrial',
            'Forestry',
            { value: 'Unaltered', label: 'Unaltered (Last 20 years)' }
        ],
    },
    {
        name: 'project_percentage',
        label: '8. What percentage of the intended project area would be cleared of vegetation?',
        type: 'number',
        view: v => `${v}%`,
    },

    "::SPACER",
    {
        name: 'prev_app',
        label: '9. Previous Application for Certificate of Environmental Clearance for this site?',
        type: 'select:bool',
    },
    {
        name: 'prev_app_ref_no',
        label: 'Reference No. of most recent application',
    },
    {
        name: 'commencement_date',
        label: '10. Intended commencement date',
        type: 'date',
    },

    "::Uploads",
    {
      name:'lease_agreement_upload',
      key: 'image.1',
      label:'Lease Agreement',
    },
    {
      name:'proof_of_land_ownership_upload',
      key: 'image.2',
      label:'Proof of Land Ownership',
    },
    {
      name:'identification_upload',
      key: 'image.3',
      label:'Document of Identification',
    },
    {
      name:'previous_c_e_c_upload',
      key: 'image.4',
      label:'Previous Certificate of Environmental Clearance (CEC)',
    },
  ]

  export { renderFormPartASummary, renderFormPartAFullDetails }
